<template>
  <div class="myview">
    <details-modal
      :show="modals.function"
      :current-operation="currentOperation"
      @cancel="closeModal"
      @create="createRecord"
      @delete="deleteRecord"
      @update="updateRecord"
    >
      <form>
        <fg-input v-model="editedFunction.name" type="text" label="Nom" />
      </form>
      <p class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
    <div class="row">
      <div class="col-md-12">
        <crud-list
          ref="crudList"
          :fetch-data="fetchFunctions"
          title="Fonctions"
          @create="create"
          @row-clicked="rowClicked"
        >
          <el-table-column label="Nom"
            ><div slot-scope="slotScope">
              {{ slotScope.row.name }}&nbsp;
            </div></el-table-column
          >
        </crud-list>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsModal from './Modals/DetailsModal.vue';
import CrudList from './CrudList.vue';

export default {
  components: {
    CrudList,
    DetailsModal,
  },
  data() {
    return {
      modals: {
        function: false,
      },
      currentOperation: {},
      editedFunction: {},
      errorMessage: ' ',
    };
  },
  methods: {
    rowClicked(row) {
      this.currentOperation = 'edit';
      this.editedFunction = { ...row };
      this.modals.function = true;
    },
    fetchFunctions(pageNumber, pageSize, searchText) {
      let url = process.env.VUE_APP_ANNUAIRE_API_URL;
      if (searchText) {
        url += `/functionEntities/search/fulltext?sort=name&name=${searchText}&page=${pageNumber -
          1}&size=${pageSize}`;
      } else {
        url += `/functionEntities?sort=name&page=${pageNumber -
          1}&size=${pageSize}`;
      }
      return this.$http.get(url).then(response => ({
        records: response.data._embedded.functionEntities
          ? response.data._embedded.functionEntities
          : [],
        page: response.data.page,
      }));
    },
    deleteRecord() {
      this.$http
        .delete(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/functions/${this.editedFunction.id}`,
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.function = false;
        })
        .catch(error => {
          this.errorMessage = error.response.data.message;
        });
    },
    updateRecord() {
      this.$http
        .patch(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/functions/${this.editedFunction.id}`,
          {
            name: this.editedFunction.name,
          },
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.function = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    createRecord() {
      this.$http
        .post(`${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/functions/`, {
          name: this.editedFunction.name,
        })
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.function = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    create() {
      this.editedFunction = {};
      this.currentOperation = 'create';
      this.modals.function = true;
    },
    closeModal() {
      this.modals.function = false;
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped></style>
